import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    toggle = (e) => {
        e.preventDefault();

        const trigger = e.currentTarget;
        const content = trigger.closest('[data-toggle-content]');
        const cName = trigger.getAttribute('data-toggle');
        const cContent = trigger.getAttribute('data-toggle-content');
        const focusInput = trigger.getAttribute('data-focus-input');

        if (cContent && document.querySelectorAll(cContent).length > 0) {
            e.preventDefault();
        }

        if (!content || (cContent && document.querySelectorAll(cContent).length > 0)) {
            trigger.classList.toggle(cName);
        }

        if (content && content != trigger) {
            content.classList.trigger(cName);
        }

        if (cContent) {
            document.querySelectorAll(cContent).forEach((element) => {
                element.classList.toggle(cName);

                if (element.querySelector(focusInput)) {
                    setTimeout(() => {
                        element.querySelector(focusInput).focus();
                    }, 100);
                }
            });
        }

        let expanded = trigger.getAttribute('aria-expanded') === 'true' || false;
        trigger.setAttribute('aria-expanded', !expanded);

        if (trigger.dataset.labelShow !== undefined && trigger.dataset.labelHide !== undefined) {
            if (expanded) {
                trigger.innerHTML = trigger.dataset.labelShow;
            } else {
                trigger.innerHTML = trigger.dataset.labelHide;
            }
        }
    };
}
